export default "__VITE_ASSET__Bum5z6ei__"